import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/nevcap-logo.svg'


const _hoisted_1 = { class: "bg-[#fffffc] min-h-screen" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "flex flex-col items-center justify-center px-6 py-16 mx-auto" }
const _hoisted_4 = { class: "w-full border border-gray-200 shadow-sm md:mt-0 sm:max-w-xl bg-white" }
const _hoisted_5 = { class: "p-6 space-y-4 md:space-y-6 sm:p-8" }
const _hoisted_6 = { class: "flex justify-center" }
const _hoisted_7 = { ref: "googleButtonRef" }
const _hoisted_8 = { class: "text-sm font-light text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex justify-center" }, [
              _createElementVNode("img", {
                alt: "Nevcap Logo",
                class: "h-10",
                src: _imports_0
              })
            ], -1)),
            _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "text-xl font-semibold leading-tight tracking-tight text-gray-900 md:text-2xl" }, " Sign in ", -1)),
            _createElementVNode("form", {
              class: "space-y-4 md:space-y-6",
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", null, [
                _cache[3] || (_cache[3] = _createElementVNode("label", {
                  class: "block mb-2 text-sm font-medium text-gray-900",
                  for: "email"
                }, "Email", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                  class: "bg-white border border-gray-300 text-gray-900 sm:text-sm focus:ring-primary focus:border-primary block w-full p-2.5",
                  name: "email",
                  placeholder: "you@company.com",
                  required: "",
                  type: "email"
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[4] || (_cache[4] = _createElementVNode("label", {
                  class: "block mb-2 text-sm font-medium text-gray-900",
                  for: "password"
                }, "Password", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "password",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                  class: "bg-white border border-gray-300 text-gray-900 sm:text-sm focus:ring-primary focus:border-primary block w-full p-2.5",
                  name: "password",
                  placeholder: "••••••••",
                  required: "",
                  type: "password"
                }, null, 512), [
                  [_vModelText, _ctx.password]
                ])
              ]),
              _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"flex items-center justify-between\" style=\"display:none;\"><div class=\"flex items-start\"><div class=\"flex items-center h-5\"><input id=\"remember\" aria-describedby=\"remember\" class=\"w-4 h-4 border border-pale-creamrounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600 dark:ring-offset-gray-800\" type=\"checkbox\"></div><div class=\"ml-3 text-sm\"><label class=\"text-gray-500 dark:text-gray-300\" for=\"remember\">Remember me</label></div></div><a class=\"text-sm font-medium text-primary hover:underline\" href=\"#\">Forgot your password?</a></div><button class=\"w-full inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-white bg-primary hover:bg-gray-700\" type=\"submit\"> Sign in <svg class=\"ml-2 -mr-1 w-5 h-5\" fill=\"currentColor\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path clip-rule=\"evenodd\" d=\"M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z\" fill-rule=\"evenodd\"></path></svg></button>", 2)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, null, 512)
              ]),
              _createElementVNode("p", _hoisted_8, [
                _cache[6] || (_cache[6] = _createTextVNode(" Don't have an account? ")),
                _createVNode(_component_router_link, {
                  class: "font-medium text-primary hover:underline",
                  to: "/register"
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode(" Register ")
                  ])),
                  _: 1
                })
              ])
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}